import React, { useState } from "react";
import { FLAGGED_MEDICATIONS } from "../../utils/flaggedMedications";

/**
 * "Please tell us if you take any of these", shown wherever a patient lists
 * their medications: on the intake form and on their Profile.
 *
 * Informational, so it is a Sand panel with a Charcoal outline and an info icon:
 * not Error red, which DESIGN_SYSTEM.md reserves for interface failures, and not a
 * severity colour. The four groups are always visible. Their medicines are open on
 * a wide screen; on a phone they start folded (tap a group to open it), because
 * open they pushed the answer box three screens down.
 */
const startOpen = () =>
  typeof window === "undefined" || !window.matchMedia || window.matchMedia("(min-width: 768px)").matches;

const MedicationNotice = () => {
  const [open] = useState(startOpen);
  return (
  <section
    aria-label="Medications your provider needs to know about"
    style={{
      border: "1px solid var(--youro-charcoal)",
      borderRadius: "10px",
      backgroundColor: "var(--youro-sand)",
      color: "var(--youro-charcoal)",
      padding: "14px 16px",
      margin: "12px 0",
      textAlign: "left",
      fontSize: "0.875rem",
      lineHeight: 1.45,
    }}
  >
    <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
      {/* lucide info */}
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0, marginTop: "1px" }}>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4" />
        <path d="M12 8h.01" />
      </svg>
      <div>
        {/* Not an h3: Patient-Homepage.css forces h2/h3 sizes with !important on
            every page, which would blow this up to a page heading. */}
        <p style={{ margin: "0 0 4px", fontSize: "0.9375rem", fontWeight: 700 }}>
          Important: tell us if you take any of these medications
        </p>
        <p style={{ margin: "0 0 8px" }}>
          Some urology treatments can interact with these medicines, and a few combinations can be dangerous.
          Please include any you take, even occasionally, so your provider can check before prescribing anything.
        </p>
        {FLAGGED_MEDICATIONS.map((group) => (
          <details key={group.id} open={open} style={{ margin: "6px 0" }}>
            <summary style={{ cursor: "pointer", fontWeight: 600 }}>{group.title}</summary>
            <ul style={{ margin: "4px 0 0", paddingLeft: "20px" }}>
              {group.names.map((n) => <li key={n}>{n}</li>)}
            </ul>
          </details>
        ))}
        {!open && (
          <p style={{ margin: "4px 0 0", color: "var(--youro-muted)" }}>Tap a group to see its medicines.</p>
        )}
        <p style={{ margin: "8px 0 0", color: "var(--youro-muted)" }}>
          Not sure whether a medicine is on this list? Include it anyway, or ask your provider at your visit.
        </p>
      </div>
    </div>
  </section>
  );
};

export default MedicationNotice;
